import { configureStore } from "@reduxjs/toolkit";
import { billDetailsReducer } from "./billDetailsSlice";
import setCartTypeReducer from '../reducers/setCartTypeReducer';
import setActiveShopHashReducer from '../reducers/setActiveShopHashReducer';
import setApiUrlReducer from '../reducers/setApiUrlReducer';
import setCateogoryReducer from '../reducers/setCateogoryReducer'
import setProductWithCatgReducer from '../reducers/setProductWithCatgReducer';
import { restoBillConfigReducer } from "./restoBillConfigSlice";
import { snpGlobalUiReducer } from "./snpGlobalUISlice";
import { authSessionReducer } from "./authSessionSlice";
import { registerAuthSessionStore } from "./authSessionRuntime";
const store  = configureStore({
    reducer: {
        bill: billDetailsReducer,
        snpGlobalUi: snpGlobalUiReducer,
        restoBillConfig: restoBillConfigReducer,
        authSession: authSessionReducer,
        setCartTypeReducer,setActiveShopHashReducer,setApiUrlReducer,setCateogoryReducer,setProductWithCatgReducer
    }
})

registerAuthSessionStore(store);

export default store;
